module.exports = __webpack_public_path__ + "img/df3d652.jpg";